// extracted by css-extract-rspack-plugin
export default {"scrollableLayout":"kyzpY","roundedBox":"C_VLE","roundedBoxTwoColumns":"kCji4","formPanel":"JrA8S","formPanelWithLeftBorder":"ML0Yo"};